import { FetchApiResponse } from "redux/types";

export enum AmortizationReportReduxTypes {
    AMORTIZATION_REPORT = "@@auth/AMORTIZATION_REPORT",
    AMORTIZATION_REPORT_SUCCESS = "@@auth/AMORTIZATION_REPORT_SUCCESS",
    AMORTIZATION_REPORT_ERROR = "@@auth/AMORTIZATION_REPORT_ERROR"
}

export type AmortizationReportActionDispatch = {
    type: | AmortizationReportReduxTypes.AMORTIZATION_REPORT;
    payload: any;
}

export type AmortizationReportReducerDispatch = {
    type: | AmortizationReportReduxTypes.AMORTIZATION_REPORT
    | AmortizationReportReduxTypes.AMORTIZATION_REPORT_SUCCESS
    | AmortizationReportReduxTypes.AMORTIZATION_REPORT_ERROR

    payload: {
        data?: FetchApiResponse<AmortizationReport>
        error?: string
    }
}

export type AmortizationReport = {
    id: string,
    financierId: string,
    userId: string,
    type: string,
    status: number,
    updatedOn: string;
    createdOn: string;
}

export type CreateAmortizationReportRequest = {
    payload: {},
    type: string
}

export type CreateAmortizationReportReduxState = {
    loading?: boolean
    data?: {},
    error?: string | null;
}